module.exports = __webpack_public_path__ + "img/Bike driver Icon - white.e07324db.svg";